import axios, { AxiosResponse } from "axios";

interface ISort {
  nm_coluna: string;
  order: string;
}

export async function getFeatures<T>(
  host_url: string,
  typeNames: string,
  bbox: string,
  sortBy: ISort[],
  page: number | null,
  geometry_name: string,
  controller?: AbortController,
  layer_query_filter?: string,
  query?: string,
  intersect_query?: string,
  allFeatures?: boolean,
): Promise<AxiosResponse<T>> {
  let cql_filter = `BBOX(${geometry_name}, ${bbox})`;

  if (intersect_query) cql_filter += ` AND [${intersect_query}]`;

  if (layer_query_filter) cql_filter += ` AND [${layer_query_filter}]`;

  if (query) cql_filter += ` AND [${query}]`;

  const params: Record<string, string> = {
    request: 'getFeature',
    service: 'WFS',
    version: '1.0.0',
    outputformat: 'application/json',
    typeNames: typeNames,
    CQL_FILTER: cql_filter,
    sortBy: sortBy.map(i => `${i.nm_coluna} ${i.order}`).join(', '),
    srsName: 'EPSG:3857',
  };

  if (!allFeatures) {
    params.startIndex = `${page}`;
    params.maxFeatures = '500';
  }


  const requestUrl = host_url + '?' + new URLSearchParams(params).toString();

  const response = await axios.get(requestUrl, {
    signal: controller?.signal,
    method: 'GET',
  });

  return response;
}

function buildCqlFilter(props: Map<string, string | number>) {
  return Object.entries(props)
    .map(([key, value]) => {
      if (value === null || value === undefined) return null;

      if (typeof value === "number") return `${key}=${value}`;

      const v = String(value).replace(/'/g, "''");
      return `${key}='${v}'`;
    })
    .join(" AND ");
}

export async function getFeature<T>(
  host_url: string,
  typeName: string,
  properties: any,
) {
  const params: Record<string, string> = {
    request: 'getFeature',
    service: 'WFS',
    version: '1.0.0',
    outputformat: 'application/json',
    typeName: typeName,
    CQL_FILTER: buildCqlFilter(properties),
    srsName: 'EPSG:3857',
    maxFeatures: '1',
  };

  const requestUrl = host_url + '?' + new URLSearchParams(params).toString();

  const response = await fetch(requestUrl, {
    method: 'GET',
    mode: 'cors',
  });

  const data: T = await response.json();

  return data;
}

